import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import TextArea from '../../../common/components/TextArea.js'
import api from '../../../common/api.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {poSelector, updatePO} from '../../../data/pos.js'

const MODAL_FORM = 'add_po_comment_modal'

export function showAddPOCommentModal(poID) {
  setForm(MODAL_FORM, {
    poID,
    comment: '',
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function close() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export async function addPOComment() {
  try {
    updateModalForm({isSaving: true})

    const {poID, comment} = modalFormSelector(getState())

    const {json} = await api.post(
      `/purchase_order/${encodeURIComponent(poID)}/comment`,
      {comment: comment.trim()},
    )

    const {comments} = poSelector(getState(), {poID})

    if (comments) {
      updatePO(poID, {comments: [json, ...comments]})
    }

    showMessageToast('PO comment was added.')

    close()
  } catch (err) {
    updateModalForm({
      serverError: `Error creating PO comment: ${
        err.message || err.error_message
      }`,
      isSaving: false,
    })
  }
}

function AddPOCommentModal({form}) {
  return (
    <ConfirmModal
      title="Add Purchase Order Comment"
      confirmText="Save"
      cancelText="Cancel"
      onConfirm={() => addPOComment()}
      onCancel={() => close()}
      isSaving={form.isSaving}
      error={form.serverError}
    >
      <ul className="list list--no-style">
        <li className="list__item--form list__item--no-style divider--bottom">
          <div className="fs-01">
            <strong>{form.poID}</strong>
          </div>
        </li>
        <li>
          <TextArea
            label="Comment"
            rows="10"
            id="comment"
            value={form.comment}
            onChange={(value) => updateModalForm({comment: value})}
            autoFocus
          />
        </li>
      </ul>
    </ConfirmModal>
  )
}

export default onlyIfForm(AddPOCommentModal, modalFormSelector)
